import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/admin/AdminSidebar/AdminSidebar';
import AdminNavbar from '../../components/admin/AdminNavbars/AdminNavbar';
import AdminBreadcrumb from '../../layout/AdminDashboardLayout/AdminBreadcrumb';
import { useSidebar } from '../../context/AdminContext';
import '../../assets/css/admin/adminPageLayout/dashboardlayout.css';
import AppContext from '../../context/AppContext';

const DashboardLayout = () => {
  const { isSidebarOpen } = useSidebar();
  const {setAuthToken} =useContext(AppContext);
   useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    setAuthToken(authToken);
  }, []);
  return (
    <div className="jj-dashboard-layout">
      <Sidebar />

      <div
        className={`jj-dashboard-main ${
          isSidebarOpen ? 'jj-dashboard-main-expanded' : 'jj-dashboard-main-collapsed'
        }`}
      >
        <AdminNavbar />
        <main className="jj-dashboard-content">
          <div className="jj-dashboard-content-wrapper">
            <AdminBreadcrumb />
            
            <Outlet />
          </div>
        </main>
      </div>

      <div
        className={`jj-mobile-overlay ${
          isSidebarOpen ? 'jj-mobile-overlay-active' : ''
        }`}
        onClick={() => {
          if (window.innerWidth <= 768) {
            document.querySelector('.jj-navbar-toggle')?.click();
          }
        }}
      ></div>
    </div>
  );
};

export default DashboardLayout;